<input type="file" class="file-input" (change)="onFileSelected($event)" #fileUpload>
<div class="file-upload">
   {{fileName || "No file uploaded yet."}}
    <button mat-raised-button class="choosebutton" color="primary" (click)="fileUpload.click()">Choose File to Upload</button>
</div>
